import React, { useEffect, useState, useRef } from "react";

import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

import Select from "react-select";

import { saveAs } from 'file-saver';

import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";

import { apiRequest } from "../api/apiRequest";

import Loading from "../components/Loading";
import Navbar from "../components/Navbar";
import SideMenu from "../components/SideMenu";

function ProjetoDeLei() {
    const { t } = useTranslation();

    const acessoProdutoTaxPl = localStorage.getItem("produto_taxpl");
    if (acessoProdutoTaxPl === null || acessoProdutoTaxPl === "false") {
        window.location.href = "/#/dashboard";
    }

    const [nomePl, setNomePl] = useState('');
    const [dataPlStart, setDataPlStart] = useState('');
    const [dataPlEnd, setDataPlEnd] = useState('');
    const [dataAtualizacaoPlStart, setDataAtualizacaoPlStart] = useState('');
    const [dataAtualizacaoPlEnd, setDataAtualizacaoPlEnd] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [plsData, setPlsData] = useState({});
    const [areaAtuacaoData, setAreaAtuacaoData] = useState([]);
    const [areaAtuacaoSelecionado, setAreaAtuacaoSelecionado] = useState([]);
    const [tipo, setTipo] = useState(null);
    const [tipoPlanilhaExportacao, setTipoPlanilhaExportacao] = useState('normal');

    const debounceTimeoutRef = useRef(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        setHasMore(true);

        const params = {
            pagina: page,
            limite_quantidade: itemsPerPage,
        };

        if (nomePl?.length > 0) {
            params.nome_pl = nomePl;
        }
        if (areaAtuacaoSelecionado?.length > 0) {
            params.areaatuacao_id = areaAtuacaoSelecionado.join(",");
        }
        if (tipo) {
            params.tipo = tipo;
        }
        if (dataPlStart) {
            params.data_pl_de = dataPlStart;
        }
        if (dataPlEnd) {
            params.data_pl_ate = dataPlEnd;
        }
        if (dataAtualizacaoPlStart) {
            params.data_atualizacao_pl_de = dataAtualizacaoPlStart;
        }
        if (dataAtualizacaoPlEnd) {
            params.data_atualizacao_pl_ate = dataAtualizacaoPlEnd;
        }

        try {
            const plsResponse = await apiRequest(
                "GET",
                `/projeto-de-lei`,
                "",
                params
            );

            setPlsData(plsResponse.data);
            setHasMore(plsResponse.data.pls?.length === itemsPerPage);
        } catch (error) {
            setError(error);
        }

        try {
            const areaAtuacaoResponse = await apiRequest("GET", `/area-atuacao-projeto-de-lei`);

            setAreaAtuacaoData(areaAtuacaoResponse.data);
        } catch (error) {
            setError(error);
        }

        setLoading(false);
    };

    const exportarExcel = async () => {
        setLoading(true);
        setError(null);

        try {
            const params = {};

            if (nomePl?.length > 0) {
                params.nome_pl = nomePl;
            }
            if (areaAtuacaoSelecionado?.length > 0) {
                params.areaatuacao_id = areaAtuacaoSelecionado.join(",");
            }
            if (tipo) {
                params.tipo = tipo;
            }
            if (dataPlStart) {
                params.data_pl_de = dataPlStart;
            }
            if (dataPlEnd) {
                params.data_pl_ate = dataPlEnd;
            }
            if (dataAtualizacaoPlStart) {
                params.data_atualizacao_pl_de = dataAtualizacaoPlStart;
            }
            if (dataAtualizacaoPlEnd) {
                params.data_atualizacao_pl_ate = dataAtualizacaoPlEnd;
            }
            params.tipo_planilha = tipoPlanilhaExportacao;

            const response = await apiRequest(
                "GET",
                `/projeto-de-lei-exportar-exel`,
                "",
                params,
                "blob"
            );

            if (!response?.data || response.data.size === 0) {
                setError(new Error("Não há dados para exportar."));
                setLoading(false);
                return;
            }

            let fileName = `relatorio_projetos_de_lei_${tipoPlanilhaExportacao}.xlsx`;
            const disposition = response.headers["content-disposition"];
            const fileNameMatch = disposition?.match(/filename="?([^"]+)"?/);
            if (fileNameMatch?.[1]) {
                fileName = fileNameMatch[1];
            }

            saveAs(response.data, fileName);

        } catch (error) {
            console.error("Erro ao gerar o Excel:", error);
            setError(new Error("Não foi possível gerar o relatório."));
        } finally {
            setLoading(false);
        }
    };

    const limparFiltros = () => {
        setNomePl('');
        setDataPlStart('');
        setDataPlEnd('');
        setDataAtualizacaoPlStart('');
        setDataAtualizacaoPlEnd('');
        setAreaAtuacaoSelecionado([]);
        setTipo(null);
        setTipoPlanilhaExportacao('normal');

        fetchData();
    };

    const handleDebouncedChange = () => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchData();
        }, 1000);
    };

    // useEffect para filtros com debounce
    useEffect(() => {
        handleDebouncedChange();

        return () => clearTimeout(debounceTimeoutRef.current);
    }, [
        nomePl
    ]);

    // useEffect para os demais filtros sem debounce
    useEffect(() => {
        fetchData();
    }, [
        dataPlStart,
        dataPlEnd,
        dataAtualizacaoPlStart,
        dataAtualizacaoPlEnd,
        itemsPerPage,
        page,
        areaAtuacaoSelecionado,
        tipo
    ]);

    useEffect(() => {
        if (!areaAtuacaoSelecionado.includes(1)) {
            setTipo(null);
        }
    }, [areaAtuacaoSelecionado]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchData();
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, []);

    const startItem = page * itemsPerPage + 1;
    const endItem = startItem + plsData.pls?.length - 1;

    const formatDate = (dateString) => {
        const [datePart] = dateString.split(" ");
        const [year, month, day] = datePart.split("-");

        return `${day}/${month}/${year}`;
    };

    const optionsAreaAtuacao = areaAtuacaoData
        ? areaAtuacaoData.map((segmento) => ({
            label: segmento.descricao ? `${segmento.nome} - ${segmento.descricao}` : segmento.nome,
            value: segmento.id,
        }))
        : [];

    const selectedOptionsAreaAtuacao = optionsAreaAtuacao.filter((option) =>
        areaAtuacaoSelecionado.includes(option.value)
    );

    const handleChangeAreaAtuacao = (selectedOptionsAreaAtuacao) => {
        setAreaAtuacaoSelecionado(
            selectedOptionsAreaAtuacao ? selectedOptionsAreaAtuacao.map((option) => option.value) : []
        );
    };

    return (
        <div id="wrapper" style={{ backgroundColor: "#043A5E" }}>
            <SideMenu />

            <div id="page-wrapper" style={{ backgroundColor: "#FCFCFD" }}>
                <Navbar />

                <div className="wrapper wrapper-content">
                    <div className="d-flex justify-content-between">
                        <div
                            className="border-0 shadow-sm bg-white p-4"
                            style={{ borderRadius: "1rem", width: "25%" }}
                        >
                            {/* Filtros */}
                            <div>
                                <div
                                    className="mb-4 custom-normal"
                                    style={{ fontSize: "25px", fontWeight: "600" }}
                                >
                                    {t("projetodelei.filters")}
                                </div>

                                <div>
                                    {/* Nome da PL */}
                                    <div className="form">
                                        <label className="control-label mt-2">
                                            {t("projetodelei.name")}
                                        </label>
                                        <input
                                            type="text"
                                            value={nomePl}
                                            onChange={(e) => setNomePl(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>

                                    {/* Area de Atuação */}
                                    <div className="mt-2">
                                        <div className="mb-2">{t("projetodelei.areaOfActivity")}</div>

                                        <Select
                                            value={selectedOptionsAreaAtuacao}
                                            isMulti
                                            name="areaatuacao"
                                            options={optionsAreaAtuacao}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={handleChangeAreaAtuacao}
                                            placeholder={t("projetodelei.selectArea")}
                                            noOptionsMessage={() => {
                                                t("projetodelei.emptyArea");
                                            }}
                                        />
                                    </div>

                                    {(() => {
                                        const showTipoFilter = areaAtuacaoSelecionado.includes(1);
                                        const optionsTipo = [
                                            { value: 'CAMARA', label: 'Câmara' },
                                            { value: 'SENADO', label: 'Senado' }
                                        ];

                                        const handleChangeTipo = (selectedOption) => {
                                            setTipo(selectedOption ? selectedOption.value : null);
                                        };

                                        const selectedOptionTipo = optionsTipo.find(option =>
                                            option.value === tipo
                                        );

                                        if (showTipoFilter) {
                                            return (
                                                <div className="mt-2">
                                                    <div className="mb-2">Tipo</div>
                                                    <Select
                                                        value={selectedOptionTipo}
                                                        isClearable
                                                        name="tipo"
                                                        options={optionsTipo}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        onChange={handleChangeTipo}
                                                        placeholder="Selecione o tipo"
                                                    />
                                                </div>
                                            );
                                        }
                                        return null;
                                    })()}

                                    {/* Tipo de planilha */}
                                    <div className="mt-2">
                                        <div className="mb-2">Tipo de planilha</div>
                                        <Select
                                            value={[
                                                { value: 'normal', label: 'Normal' },
                                                { value: 'consolidada', label: 'Consolidada' }
                                            ].find(option => option.value === tipoPlanilhaExportacao)}
                                            name="tipo_planilha"
                                            options={[
                                                { value: 'normal', label: 'Normal' },
                                                { value: 'consolidada', label: 'Consolidada' }
                                            ]}
                                            className="basic-single"
                                            classNamePrefix="select"
                                            onChange={(selectedOption) => setTipoPlanilhaExportacao(selectedOption?.value || 'normal')}
                                            placeholder="Selecione o tipo"
                                        />
                                    </div>

                                    {/* Data de publicação */}
                                    <div className="form">
                                        <label className="control-label mt-2">
                                            {t("projetodelei.publicationDate")}
                                        </label>

                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "10px",
                                                marginTop: "2px",
                                            }}
                                        >
                                            {/* De */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                }}
                                            >
                                                <span style={{ width: "30px", textAlign: "left" }}>
                                                    {t("projetodelei.from")}:
                                                </span>

                                                <div style={{ position: "relative", flex: 1 }}>
                                                    <input
                                                        type="date"
                                                        value={dataPlStart}
                                                        onChange={(e) => setDataPlStart(e.target.value)}
                                                        style={{
                                                            width: "100%",
                                                            padding: "13px",
                                                            paddingRight: "35px",
                                                            border: "1px solid #E5E7EB",
                                                            borderRadius: "7px",
                                                            fontSize: "14px",
                                                            color: "#6C737F",
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            {/* Até */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                }}
                                            >
                                                <span style={{ width: "30px", textAlign: "left" }}>
                                                    {t("projetodelei.to")}:
                                                </span>

                                                <div style={{ position: "relative", flex: 1 }}>
                                                    <input
                                                        type="date"
                                                        value={dataPlEnd}
                                                        onChange={(e) => setDataPlEnd(e.target.value)}
                                                        style={{
                                                            width: "100%",
                                                            padding: "13px",
                                                            paddingRight: "35px",
                                                            border: "1px solid #E5E7EB",
                                                            borderRadius: "7px",
                                                            fontSize: "14px",
                                                            color: "#6C737F",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Data de atualização */}
                                    <div className="form">
                                        <label className="control-label mt-2">
                                            {t("projetodelei.updateDate")}
                                        </label>

                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "10px",
                                                marginTop: "2px",
                                            }}
                                        >
                                            {/* De */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                }}
                                            >
                                                <span style={{ width: "30px", textAlign: "left" }}>
                                                    {t("projetodelei.from")}:
                                                </span>

                                                <div style={{ position: "relative", flex: 1 }}>
                                                    <input
                                                        type="date"
                                                        value={dataAtualizacaoPlStart}
                                                        onChange={(e) => setDataAtualizacaoPlStart(e.target.value)}
                                                        style={{
                                                            width: "100%",
                                                            padding: "13px",
                                                            paddingRight: "35px",
                                                            border: "1px solid #E5E7EB",
                                                            borderRadius: "7px",
                                                            fontSize: "14px",
                                                            color: "#6C737F",
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            {/* Até */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                }}
                                            >
                                                <span style={{ width: "30px", textAlign: "left" }}>
                                                    {t("projetodelei.to")}:
                                                </span>

                                                <div style={{ position: "relative", flex: 1 }}>
                                                    <input
                                                        type="date"
                                                        value={dataAtualizacaoPlEnd}
                                                        onChange={(e) => setDataAtualizacaoPlEnd(e.target.value)}
                                                        style={{
                                                            width: "100%",
                                                            padding: "13px",
                                                            paddingRight: "35px",
                                                            border: "1px solid #E5E7EB",
                                                            borderRadius: "7px",
                                                            fontSize: "14px",
                                                            color: "#6C737F",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* limpar filtros */}
                                    <div className="d-flex justify-content-start">
                                        <button
                                            className="btn btn-primary mt-4"
                                            onClick={() => limparFiltros()}
                                        >
                                            {t("projetodelei.clearFilters")}
                                        </button>

                                        {/* exportar exel */}
                                        <button
                                            className="btn btn-success mt-4 ml-2"
                                            onClick={exportarExcel}
                                            disabled={loading} // opcional, desabilita enquanto carrega
                                        >
                                            {loading ? "Gerando Excel..." : t("projetodelei.exportExel")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ width: "73%" }}>
                            <div className="w-100">
                                <div className="d-flex justify-content-between align-items-center mt-4 mb-4 w-100">
                                    <div
                                        className="pl-4 custom-normal"
                                        style={{ fontSize: "34px", fontWeight: "600" }}
                                    >
                                        {t("projetodelei.standardsLibrary")}
                                    </div>
                                </div>

                                <div className="bg-white" style={{ borderRadius: "1rem" }}>
                                    {loading && (
                                        <div style={{ textAlign: "center", padding: "20px" }}>
                                            <Loading />
                                        </div>
                                    )}

                                    {error && (
                                        <div style={{ textAlign: "center", padding: "20px" }}>
                                            Erro: {error.message}
                                        </div>
                                    )}

                                    {!loading && plsData.pls?.length <= 0 && !error ? (
                                        <div style={{ textAlign: "center", padding: "20px" }}>
                                            {t("projetodelei.noDataAvailable")}
                                        </div>
                                    ) : (
                                        <></>
                                    )}

                                    {!loading &&
                                        !error &&
                                        plsData.pls &&
                                        plsData.pls?.length > 0 ? (
                                        plsData.pls.map((pls) => (
                                            <div
                                                className="d-flex flex-column align-items-end"
                                                key={pls.id}
                                            >
                                                <div className="d-flex justify-content-between align-items-center px-3 py-3 w-100">
                                                    <div style={{ width: "45%" }}>
                                                        <Link
                                                            to={`/projetodelei/${pls.id}`}
                                                            style={{ color: "#232730" }}
                                                        >
                                                            <h3> {pls.nome}</h3>
                                                        </Link>
                                                    </div>

                                                    <div>
                                                        <div className="font-weight-light">
                                                            {formatDate(pls.data_pl)} Atualizado em {formatDate(pls.atualizado)}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className="border-bottom"
                                                    style={{ width: "97%" }}
                                                ></div>
                                            </div>
                                        ))
                                    ) : (
                                        <></>
                                    )}
                                </div>

                                {/* Paginação */}
                                <div className="d-flex justify-content-end align-items-center py-2">
                                    <div className="mr-4">
                                        {" "}
                                        {t("projetodelei.documentsPerPage")}
                                    </div>

                                    <select
                                        className="mr-4"
                                        style={{ border: "none" }}
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            setItemsPerPage(parseInt(e.target.value));
                                            setPage(0);
                                        }}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                    </select>

                                    <div className="mr-4">
                                        {t("projetodelei.showing")} {startItem}-{endItem}
                                    </div>

                                    <div
                                        className="mr-4"
                                        style={{
                                            fontSize: "20px",
                                            cursor: page === 0 ? "default" : "pointer",
                                            opacity: page === 0 ? 0.5 : 1,
                                        }}
                                        onClick={() => {
                                            if (page > 0) {
                                                setPage(page - 1);
                                            }
                                        }}
                                    >
                                        <RiArrowLeftSLine />
                                    </div>

                                    <div
                                        className="mr-4"
                                        style={{
                                            fontSize: "20px",
                                            cursor: hasMore ? "pointer" : "default",
                                            opacity: hasMore ? 1 : 0.5,
                                        }}
                                        onClick={() => {
                                            if (hasMore) {
                                                setPage(page + 1);
                                            }
                                        }}
                                    >
                                        <RiArrowRightSLine />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProjetoDeLei;
